//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { RequestError } from '@utils/sessionFetch';

/**
 * Checks for an instance of a `RequestError` (the form of error outputted by gateway request failures)
 * and returns the appropriate errorCode number.
 *
 * @param e Suspected `RequestError`. These are automatically typed as `unknown` in catch statements
 * as of Typescript 4.4.
 */
export const getRequestErrorCode = (e: unknown) => {
  // The given error was properly constructed as a RequestError
  if (e instanceof RequestError) {
    const context = e.context as number | undefined;
    return context ?? e.statusCode;
  } else {
    return undefined;
  }
};
